// In development: proxied via package.json "proxy" → localhost:3001
// In production (Cloudflare Pages): set REACT_APP_API_URL to your Render backend URL
const BASE = process.env.REACT_APP_API_URL || '/api';

function getToken() {
  return localStorage.getItem('qm_token');
}

function setToken(t) {
  if (t) localStorage.setItem('qm_token', t);
  else localStorage.removeItem('qm_token');
}

async function request(path, options = {}) {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
  const res = await fetch(BASE + path, {
    ...options,
    headers: { ...headers, ...options.headers },
  });
  if (res.status === 401) {
    setToken(null);
    window.location.reload();
    return;
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
}

const api = {
  get:    (path)        => request(path),
  post:   (path, body)  => request(path, { method: 'POST',   body: JSON.stringify(body) }),
  put:    (path, body)  => request(path, { method: 'PUT',    body: JSON.stringify(body) }),
  patch:  (path, body)  => request(path, { method: 'PATCH',  body: JSON.stringify(body) }),
  delete: (path)        => request(path, { method: 'DELETE' }),
  getToken,
  setToken,
  // Returns the full URL for direct browser navigation (PDF downloads)
  url: (path) => BASE + path,
};

export default api;
